module.exports = __webpack_public_path__ + "img/N351-2.ee9e4699.png";